import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-4 pt-24 text-center">
      <p className="font-heading text-7xl font-black text-primary-100 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        抱歉，这个页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的内容可能已被移除或链接有误。别担心，回到首页，或从下面的频道继续探索台北娜娜的世界。
      </p>
      <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          品牌动态
        </Link>
        <Link
          to="/lifestyle"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          生活方式
        </Link>
        <Link
          to="/trend"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          潮流趋势
        </Link>
      </div>
    </div>
  );
}